import { bemClassNames } from "@multiweb/reactUtils";

export const classNames = bemClassNames("measurer");
